module.exports = __webpack_public_path__ + "img/9-white+.2b63fb56.png";